import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=0c5dd5cc&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=js&"
export * from "./Rules.vue?vue&type=script&lang=js&"
import style0 from "./Rules.vue?vue&type=style&index=0&id=0c5dd5cc&scoped=true&lang=css&"
import style1 from "./Rules.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5dd5cc",
  null
  
)

export default component.exports